import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { useLoadingAnimation } from '@/components/LoadingAnimation/useLoadingAnimation.hook';
import { notificationService } from '@/services/notification/notification.client';
import AddPurchaseOrderMutation from '@/graphql/contracts/addPurchaseOrder.mutation.gql';
import {
  AddPurchaseOrderInputType,
  ContractsAndBillingMutation,
  ContractsAndBillingMutationaddPurchaseOrderArgs,
} from '@/graphql/contracts/_generated_/contracts';

export default function useAddPurchaseOrder() {
  useLoadingAnimation();
  
  const [addPurchaseOrder, { loading, error }] = useMutation<
  ContractsAndBillingMutation,
  ContractsAndBillingMutationaddPurchaseOrderArgs
  >(AddPurchaseOrderMutation, {
    client: apolloClientContracts,
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const addNewPurchaseOrder = (
    fields: { input: AddPurchaseOrderInputType }, 
    successCb?: ((createdPO: any) => void) | (() => void)
  ) => {
    addPurchaseOrder({
      variables: { ...fields },
      onCompleted: (data) => {
        notificationService.open({
          title: 'Add New Purchase Order',
          text: 'New Purchase Order successfully added',
          type: 'success',
        });
        if (successCb) {
          if (successCb.length > 0 && data.addPurchaseOrder) {
            (successCb as (createdPO: any) => void)(data.addPurchaseOrder);
          } else {
            (successCb as () => void)();
          }
        }
      },
    });
  };
 
  return {
    addNewPurchaseOrder,
    isLoadingAddNewPurchaseOrder: loading,
    errorAddNewPurchaseOrders: error,
  } as const;
}
